<div class="el-breadcrumb-wrapper">
    <div class="container ">
        <div class="el-breadcrmb-inner  ">
            <h1 style="color: #e04787;">Mock Test Details</h1>
            <ul>


                <li class="ms-3">
                    <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- Breadcrumb Start -->

<div class="el-team-wrapper">
    <div class="container">

        <div class="el-team-parent">
            <div class="d-flex justify-content-center" *ngIf="IsShowMessage">
                <div class="col-md-5 alert">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"
                        style="font-size: 50px;color: #e04787;"></i>
                    <br><br>

                    <div *ngIf="this.PREP_UserInfo.childId!=null">
                        You have not purchased any plan for <strong>{{this.PREP_UserInfo.childName}}
                        </strong> of <strong *ngIf="PREP_UserInfo.classId <= '12'">Class
                            {{PREP_UserInfo.classId}}.</strong> <strong *ngIf="PREP_UserInfo.classId > '12'">Class
                            {{PREP_UserInfo.className}}.</strong>
                        <br><br>
                        <a [routerLink]="['/product']" class="el-btn"> <strong>Buy Now</strong></a>
                    </div>
                    <div *ngIf="this.PREP_UserInfo.childId==null">
                        No child added yet. Kindly add a child to proceed.
                        <br><br>
                        <a (click)="Switch_Child()" class="el-btn"> <strong>Add Child</strong></a>
                    </div>
                </div>
            </div>


            <div class="row" style="margin-bottom: 50px;" *ngIf="DataList.length>0">
                <div class="col-md-4">
                    <label>Subject</label>
                    <select class="form-control" [(ngModel)]="Subject" (change)="Subject_Changed()">
                        <option value="All">All</option>
                        <option *ngFor="let _obj of SubjectList" [value]="_obj.SubjectName">{{_obj.SubjectName}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row gy-3" style="margin-top: 50px;">
                <div class="col-lg-4 col-md-6" *ngFor="let _obj of DataList" style="margin-bottom: 50px;">
                    <div class="el-price-box">
                        <div class="el-price-inner">
                            <h4 class="el-popular-plan">{{_obj.MockTest}}</h4>
                            <div class="el-price-head">
                                <div class="el-price-img d-flex justify-content-between align-items-center">
                                    <h4 class="theme-color">

                                        <span *ngIf="_obj.Marks!=null">
                                            <span class="text-dark">{{_obj.childName}}</span><br>
                                            <small>Obtained Marks</small> <br>
                                            {{_obj.Marks}}<span class="text-dark">/100</span></span>

                                    </h4>
                                    <img [src]="_obj.BookImage" alt="icon" width="100px">



                                </div>
                                <p class="el-para">{{ _obj.PlanTitle }}</p>
                                <a *ngIf="_obj.examStatus==''" href="javascript:;" (click)="Process(_obj)"
                                    class="el-btn">Proceed Now</a>

                                <a *ngIf="_obj.examStatus=='Test submitted'" href="/ProgressReport?id={{_obj.id}}"
                                    class="el-btn " style="background-color:#2b964b;color:white; ">
                                    View Progress Report
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>